import sx from 'utils/createSx';

export default sx({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
});
